export const CONTACT = {
  name: "K.O CHEF & CATERING LLC",
  tagline: "Where Flavor Meets Unforgettable Experiences",
  email: "info@kochefcatering.com",
  phoneEn: "(239) 898-5508",
  phoneEnName: "Manny",
  phoneEs: "(786) 915-7089",
  phoneEsName: "Ricardo",
  areas: "Naples · Bonita Springs · Fort Myers & Surrounding Areas",
  instagram: "https://instagram.com/kochefcatering",
  instagramHandle: "@kochefcatering",
  facebook: "https://facebook.com/kochefcatering",
  hours: [
    { d: "Monday – Friday", h: "9:00 AM – 8:00 PM" },
    { d: "Saturday", h: "10:00 AM – 9:00 PM" },
    { d: "Sunday", h: "By Appointment" },
  ],
};

export const NAV = [
  { label: "Home", to: "/" },
  { label: "About", to: "/about" },
  {
    label: "Services", to: "/services",
    children: [
      { label: "All Catering Services", to: "/services" },
      { label: "Wedding Catering", to: "/services/wedding-catering" },
      { label: "Corporate Events", to: "/services/corporate-catering" },
      { label: "Private Chef Experience", to: "/services/private-chef" },
      { label: "Social Events", to: "/services/social-events" },
      { label: "Luxury Events", to: "/services/luxury-events" },
    ],
  },
  { label: "Build Your Menu", to: "/build-your-menu" },
  { label: "Packages", to: "/packages" },
  { label: "Gallery", to: "/gallery" },
  {
    label: "More", to: "/faq",
    children: [
      { label: "Testimonials", to: "/testimonials" },
      { label: "FAQ", to: "/faq" },
      { label: "Contact", to: "/contact" },
    ],
  },
];

export const SERVICES = [
  { slug: "wedding-catering", title: "Wedding Catering", tag: "Say 'I do' to unforgettable flavor",
    image: "https://images.unsplash.com/photo-1665607437981-973dcd6a22bb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "From intimate ceremonies to grand receptions, we craft bespoke wedding menus that reflect your love story. White-glove service, elegant plating, and cuisine your guests will remember forever.",
    features: ["Custom tasting sessions", "Plated & buffet options", "Cocktail hour canapés", "Full service staff & setup"] },
  { slug: "corporate-catering", title: "Corporate Catering", tag: "Impress clients & reward teams",
    image: "https://images.unsplash.com/photo-1576842546422-60562b9242ae?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Elevate boardroom lunches, product launches, and company celebrations with professional, punctual catering that reflects your brand's excellence.",
    features: ["Boxed & buffet lunches", "Live chef stations", "Corporate accounts", "On-time delivery guarantee"] },
  { slug: "private-chef", title: "Private Chef Experience", tag: "Fine dining in your home",
    image: "https://images.unsplash.com/photo-1748778292263-1d503e8ae93d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "A restaurant-quality multi-course experience prepared and served in the comfort of your home. Perfect for anniversaries, date nights, and intimate gatherings.",
    features: ["Personalized multi-course menus", "In-home preparation", "Wine pairing guidance", "Full cleanup included"] },
  { slug: "birthday-parties", title: "Birthday Parties", tag: "Celebrate in style",
    image: "https://images.unsplash.com/photo-1527751171053-6ac5ec50000b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Make every milestone delicious. From kids' celebrations to milestone birthdays, our menus bring color, flavor, and fun to your special day.",
    features: ["Themed menus", "Dessert displays", "Kid-friendly options", "Flexible packages"] },
  { slug: "meal-prep", title: "Meal Prep", tag: "Gourmet, ready when you are",
    image: "https://images.unsplash.com/photo-1676471926534-d5c9771909fa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Chef-prepared weekly meals tailored to your goals and tastes. Fresh ingredients, balanced nutrition, and flavor that makes healthy eating effortless.",
    features: ["Weekly rotating menus", "Dietary customization", "Fresh, never frozen", "Convenient delivery"] },
  { slug: "holiday-catering", title: "Holiday Catering", tag: "Season's finest table",
    image: "https://images.unsplash.com/photo-1649615644613-758b850399c1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Let us handle the feast so you can enjoy the season. Traditional favorites and elevated classics for Thanksgiving, Christmas, and every celebration in between.",
    features: ["Seasonal specialties", "Family-style platters", "Heat-and-serve options", "Early booking discounts"] },
  { slug: "cocktail-parties", title: "Cocktail Parties", tag: "Elegant bites & bespoke bars",
    image: "https://images.unsplash.com/photo-1574862612978-33bdb5f6a334?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Sophisticated passed hors d'oeuvres and curated mocktail bars that keep the conversation flowing. Perfect for networking events and soirées.",
    features: ["Passed canapés", "Grazing tables", "Mocktail & bar service", "Elegant presentation"] },
  { slug: "bbq-events", title: "BBQ Events", tag: "Southern smoke, gourmet touch",
    image: "https://images.unsplash.com/photo-1583338917496-7ea264c374ce?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Low-and-slow smoked meats and elevated cookout classics. Casual comfort with a refined, chef-driven approach for backyard gatherings and festivals.",
    features: ["Smoked meats & ribs", "Signature sauces", "Live grill stations", "Classic sides"] },
  { slug: "family-gatherings", title: "Family Gatherings", tag: "Bring everyone to the table",
    image: "https://images.unsplash.com/photo-1561593367-66c79c2294e6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Warm, generous, family-style spreads that turn any reunion into a feast. We handle the cooking so you can savor the moments that matter.",
    features: ["Family-style service", "Generous portions", "Comfort classics", "Kid-friendly menus"] },
  { slug: "social-events", title: "Social Events", tag: "Every gathering, elevated",
    image: "https://images.unsplash.com/photo-1481980275825-c31d8c8482b2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Showers, graduations, retirements, and everything worth celebrating. Custom menus and seamless service for your most memorable social occasions.",
    features: ["Custom event menus", "Décor coordination", "Flexible guest counts", "Full-service options"] },
  { slug: "luxury-events", title: "Luxury Events", tag: "The pinnacle of hospitality",
    image: "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    desc: "Gala dinners, VIP experiences, and exclusive celebrations executed with uncompromising attention to detail. When only the extraordinary will do.",
    features: ["Premium proteins & caviar", "Bespoke menu design", "Full event production", "Dedicated event manager"] },
];

export const EVENT_TYPES = ["Wedding", "Corporate", "Birthday", "Private Dinner", "Cocktail Party", "Holiday", "Social Event", "Luxury Gala"];
export const ADDITIONAL_SERVICES = ["Full Service Staff", "Bartender", "Setup & Cleanup", "China & Glassware Rental", "Floral & Décor", "Live Chef Station"];
export const MENU_CATEGORIES = ["Appetizers", "Salads", "Main Courses", "Side Dishes", "Desserts", "Beverages"];
